import { render, staticRenderFns } from "./TagMultiselect.vue?vue&type=template&id=91588d96&scoped=true&"
import script from "./TagMultiselect.vue?vue&type=script&lang=ts&"
export * from "./TagMultiselect.vue?vue&type=script&lang=ts&"
import style0 from "./TagMultiselect.vue?vue&type=style&index=0&id=91588d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91588d96",
  null
  
)

export default component.exports